<template>
    <div v-if="viewId" class="card">
        <div class="card-body">
            <table class="table table-sm mb-0">
                <thead>
                <tr>
                    <th v-for="column in columns" :key="column.id">{{ column.title }}</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td v-for="column in columns"  :key="column.id">
                        <TableCell :id="item.id" :column-id="column.id" :view-id="viewId"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import view from '../../store/modules/view'

import TableCell from '../../common/table-cell/TableCell'

export default {
    name: "FormControlTypeTable",
    components: {
        TableCell,
    },
    props: {
        formId: String,
        field: Object,
        currentData: Object,
    },
    data() {
        return {
            viewId: ''
        }
    },
    computed: {
        listingName() {
            return this.tableName + '.' + this.field.name
        },
        column() {
            return this.$store.getters['componentStructure/getItem'](this.field.tableTargetColumn)
        },
        componentId() {
            return this.column.modulecomponentsID || this.column.modulecomponentsId
        },
        tableName() {
            return this.$store.state.components.items.find(o => o.id === this.componentId).tableName
        },
        columns() {
            return this.$store.getters['componentStructure/get'](this.componentId)
                .filter(o => o.browser)
        }
    },
    asyncComputed: {
        items() {
            return this.$store.dispatch('request/get', {
                url: 'api/component/' + this.tableName,
                params: {
                    // E.g. orderId: 123
                    [this.column.columnName]: this.currentData.id
                }
            }).then((obj) => {
                return obj.data.items
            })
        }
    },
    created() {
        // todo This had to be converted from a computed property because it caused an infinite loop
        const viewId = 'view:' + this.listingName

        // As users move to and from listings we only want to register modules which don't yet exist,
        // so to preserve the user's settings for each module.
        if (!this.$store.hasModule(viewId)) {
            this.$store.registerModule(viewId, view)
        }
        this.$store.dispatch(viewId + '/init', {
            listingName: this.listingName,
        })

        this.viewId = viewId
    }
}
</script>

<style scoped>
.table {
    font-size: .8rem;
}
</style>